import { findById } from '@/utils/index'

export default {
    namespaced: true,

    state: () => ({
        automations:[],
    }),
    getters:{
        allAutomations: state => state.automations || '[]',
        getById: (state) => (id) => {
            return state.automations.find( item => item.id === id )
        },
        automation: (state) => {
            return (id) => {
                const automation = findById(state.automations, id)
                if (!automation) return null
                return {
                    ...automation,
                }
            }
        },
        
    },
    actions:{
        createAutomation({commit, state}, value){
            value.user_id = state.user.id
            commit('save', value)
        },

    },
    mutations: {
        set_automations:(state, data) => state.automations = (data),
        save_automation:(state, automation) => state.automations.push( automation ),
        update_automation(state, data) {
            const index = state.automations.findIndex(a => a.id === data.id)
            if(index !== -1)  state.automations.splice(index, 1, data)
        },
        remove_automation: (state, id) => state.automations = state.automations.filter(a => a.id !== id),

        STORE_AUTOMATIONS(state, automations) {
            state.automations = automations
        },
    },
};
